"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = appDomain;

var _Enums = require("./Enums.json");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function appDomain(_ref) {
  var _AppName$Arcs$AppName;

  var app = _ref.app,
      env = _ref.env;
  var domain = (_AppName$Arcs$AppName = {}, _defineProperty(_AppName$Arcs$AppName, _Enums.AppName.Arcs, 'arcs.app'), _defineProperty(_AppName$Arcs$AppName, _Enums.AppName.Drops, 'drops.fm'), _AppName$Arcs$AppName)[app];

  if (!domain) {
    throw new Error("No domain defined for ".concat(app));
  }

  var subdomain = {
    dev: 'dev',
    stg: 'stg'
  }[env];

  if (subdomain) {
    domain = "".concat(subdomain, ".").concat(domain);
  }

  return domain;
}